<template>
<div class="chapter">
<div class="inner_page">
<p class="sp-brk"> </p>
<p class="cn"> </p>
<p class="fmh"><span class="epub-b">CONTENTS</span></p>
<p class="cfmh"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="cfmh"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="cfmh"><a href="#/xhtml/aunote#aun">Author’s Note</a></p>
<p class="cfmh"><span href="#/xhtml/dramatis#drama" title="Link target outside of Sample">Dramatis Personae</span></p>
<p class="cfmh"><a href="#/xhtml/foreword#fore">Foreword</a></p>
<p class="cct"><a href="#/xhtml/map#map">Map of War Zone C May–June 1970</a></p>
<p class="cct"><a href="#/xhtml/intro#intro">Introduction</a></p>
<p class="cct">  <a href="#/xhtml/chapter1#ch1">1 Alpha Troop: Men of Iron, Steeds of Steel</a></p>
<p class="cct">  <a href="#/xhtml/chapter2#ch2">2 Company A, 2nd Battalion, 8th Cavalry</a></p>
<p class="cct">  <span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">3 Company C, 2nd Battalion, 8th Cavalry</span></p>
<p class="cct">  <span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">4 “Humping Jungle”</span></p>
<p class="cct">  <span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">5 One Bad Round Can Ruin Your Whole Day …</span></p>
<p class="cct">  <span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">6 Firestorm</span></p>
<p class="cct">  <span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">7 Big Brother Is Watching</span></p>
<p class="cct">  <span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">8 “Saddle Up”</span></p>
<p class="cct">  <span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">9 Tough Choices</span></p>
<p class="cct"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">10 “Busting Jungle”</span></p>
<p class="cct"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">11 Angel of Mercy</span></p>
<p class="cct"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">12 Encouraging Words</span></p>
<p class="cct"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">13 Breakthrough</span></p>
<p class="cct"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">14 “Commence Fire!”</span></p>
<p class="cct"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">15 Slugfest</span></p>
<p class="cct"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">16 The High-Water Mark</span></p>
<p class="cct"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">17 Peregrinations</span></p>
<p class="cct"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">18 “And That’s All She Wrote…”</span></p>
<p class="cct"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">19 Battle of the Senses</span></p>
<p class="cct"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">20 Recall</span></p>
<p class="cct"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">21 Afterword</span></p>
<p class="cct"><span href="#/xhtml/epilogue#epil" title="Link target outside of Sample">Epilogue</span></p>
<p class="cbmh"><span href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="cbmh"><span href="#/xhtml/app1#app1" title="Link target outside of Sample">Appendix 1: Text of President Obama’s Speech on October 20, 2009</span></p>
<p class="cbmh"><span href="#/xhtml/app2#app2" title="Link target outside of Sample">Appendix 2: The Blackhorse Regiment, the 11th Armored Cavalry</span></p>
<p class="cbmh"><span href="#/xhtml/app3#app3" title="Link target outside of Sample">Appendix 3: The M-551 Sheridan Tank</span></p>
<p class="cbmh"><span href="#/xhtml/app4#app4" title="Link target outside of Sample">Appendix 4: The M-113 Armored Cavalry Assault Vehicle (ACAV)</span></p>
<p class="cbmh"><span href="#/xhtml/notes#notes" title="Link target outside of Sample">Notes</span></p>
<p class="cbmh"><span href="#/xhtml/glossary#gl" title="Link target outside of Sample">Glossary</span></p>
<p class="cbmh"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="cbmh"><span href="#/xhtml/index#indx" title="Link target outside of Sample">Index</span></p>
<p class="cbmh"><span href="#/xhtml/copyright#crp" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2fc81291